export const environment = {
  development: true,
  production: false,
  apiReports: 'https://api.dev.bosch-ridecare.com/reports',
  hostV2: 'https://my.dev.bosch-ridecare.com',
  host: 'https://geotab.dev.bosch-ridecare.com',
  dashboardURL: 'https://api.dev.bosch-ridecare.com',
  geoTabURL: 'https://geotab.dev.bosch-ridecare.com',
};
